/**
 * Informazioni sul Travel Advisor
 */
export interface IAdvisorInfo {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  /** Foto profilo, se caricata: la passa UserAvatar come imageUrl. */
  avatarUrl?: string | null;
  // Stripe Connect fields
  stripeAccountId?: string | null;
  stripeChargesEnabled?: boolean;
  stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;
}

/**
 * Classe che rappresenta le informazioni di un Travel Advisor
 */
export class AdvisorInfo implements IAdvisorInfo {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  avatarUrl?: string | null;
  // Stripe Connect fields
  stripeAccountId?: string | null;
  stripeChargesEnabled?: boolean;
  stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;

  constructor(data: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    avatarUrl?: string | null;
    // Stripe Connect fields
    stripeAccountId?: string | null;
    stripeChargesEnabled?: boolean;
    stripeAccountStatus?: 'not_connected' | 'pending' | 'active' | 'restricted' | null;
  }) {
    this.id = data.id;
    this.firstName = data.firstName || '';
    this.lastName = data.lastName || '';
    this.email = data.email || '';
    this.avatarUrl = data.avatarUrl ?? null;
    this.stripeAccountId = data.stripeAccountId;
    this.stripeChargesEnabled = data.stripeChargesEnabled;
    this.stripeAccountStatus = data.stripeAccountStatus;
  }

  /**
   * Nome completo del Travel Advisor
   */
  get fullName(): string {
    return `${this.firstName} ${this.lastName}`.trim();
  }

  /**
   * Verifica se l'advisor ha dati validi
   */
  get isValid(): boolean {
    return !!(this.firstName && this.lastName && this.email);
  }
}
